import React, { useState } from 'react';
import './OnboardingModals.css';

export const GenderSelectModal = ({ onSelect }) => {
    const [selected, setSelected] = useState(null);

    const handleConfirm = () => {
        if (selected) {
            onSelect(selected);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content gender-modal">
                <h2>Select Your Gender</h2>
                <p>Please select your gender to help us find the best matches for you.</p>

                <div className="gender-options">
                    <button
                        className={`gender-btn ${selected === 'male' ? 'active' : ''}`}
                        onClick={() => setSelected('male')}
                    >
                        👨 Male
                    </button>
                    <button
                        className={`gender-btn ${selected === 'female' ? 'active' : ''}`}
                        onClick={() => setSelected('female')}
                    >
                        👩 Female
                    </button>
                </div>

                <div className="modal-actions">
                    <button
                        className="confirm-btn"
                        disabled={!selected}
                        onClick={handleConfirm}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
};

export const ProfileUpdatePrompt = ({ onUpdateNow, onLater }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content update-modal">
                <div className="modal-icon">📸</div>
                <h2>Time to Shine! ✨</h2>
                <p>You've been exploring for a while. To get more attention and meet more people, you need a profile photo!</p>
                <p className="sub-text">Profiles with photos get 10x more messages.</p>

                <div className="modal-actions vertical">
                    <button className="confirm-btn" onClick={onUpdateNow}>
                        Update Profile Now
                    </button>
                    {/* Optional: Allow closing if we don't want to be strictly blocking, 
                        but user requested "give them a prompt", usually implies a strong nudge. 
                        We'll leave no "Later" button based on the strict tone of the request, 
                        or maybe a subtle one if needed. Let's stick to strict for now 
                        or make 'onLater' available but less visible. 
                    */}
                </div>
            </div>
        </div>
    );
};

export const PhoneNumberModal = ({ onSave, onSkip }) => {
    const [countryCode, setCountryCode] = useState('+254');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [error, setError] = useState('');

    const handleSave = () => {
        if (!phoneNumber || phoneNumber.length < 9) {
            setError('Please enter a valid phone number');
            return;
        }

        // Remove leading zero if present
        const cleanNumber = phoneNumber.startsWith('0') ? phoneNumber.slice(1) : phoneNumber;
        const fullNumber = `${countryCode}${cleanNumber}`;
        onSave(fullNumber);
    };

    const countryCodes = [
        { code: '+254', label: '🇰🇪 Kenya (+254)' },
        { code: '+1', label: '🇺🇸 USA (+1)' },
        { code: '+44', label: '🇬🇧 UK (+44)' },
        { code: '+91', label: '🇮🇳 India (+91)' },
        { code: '+234', label: '🇳🇬 Nigeria (+234)' },
        { code: '+27', label: '🇿🇦 South Africa (+27)' },
        { code: '+256', label: '🇺🇬 Uganda (+256)' },
        { code: '+255', label: '🇹🇿 Tanzania (+255)' },
    ];

    return (
        <div className="modal-overlay">
            <div className="modal-content phone-modal">
                <div className="modal-icon">📱</div>
                <h2>Verify Your Number</h2>
                <p>Add your phone number for secure cashouts via M-Pesa and WhatsApp updates.</p>

                <div className="phone-input-group">
                    <select
                        value={countryCode}
                        onChange={(e) => setCountryCode(e.target.value)}
                        className="country-select"
                    >
                        {countryCodes.map((c) => (
                            <option key={c.code} value={c.code}>
                                {c.label}
                            </option>
                        ))}
                    </select>
                    <input
                        type="tel"
                        value={phoneNumber}
                        onChange={(e) => {
                            setPhoneNumber(e.target.value.replace(/\D/g, ''));
                            setError('');
                        }}
                        placeholder="712 345 678"
                        className="phone-input"
                    />
                </div>

                {error && <p className="error-text">{error}</p>}

                <div className="modal-actions vertical">
                    <button className="confirm-btn" onClick={handleSave}>
                        Save Number
                    </button>
                </div>
            </div>
        </div>
    );
};
